<template>
  <div class="news_inner_header flex column">
    <div
      class="news_inner_header__ttl_wrapper flex j_sb container a_center wc-lg"
    >
      <BreadCrumb />
      <div class="news_inner_header__socials flex a_center">
        <span class="f-14 regular">{{ $fn.tr("გააზიარე:") }}</span>
        <a
          target="_blank"
          class="news_inner_header__socials--icon pointer"
          v-for="(icon, index) in share_icons"
          :key="index"
          @click.stop="openSharePopup(icon.url)"
        >
          <div v-html="_.get(icon, 'svg')"></div>
        </a>
      </div>
    </div>
    <div class="news_inner_header--categories flex container wc-lg">
      <h2 class="f-38 bold uppercase">{{ news_title }}</h2>
    </div>
    <div class="news_inner_header__searchbox container wc-lg flex column">
      <div class="news_inner_header__searchbox--inner  flex j_sb">
        <div class="news_inner_header--tags flex w-full">
          <div
            class="news_inner_header--tag  br-6 bg_gray flex a_center"
            v-for="(tag, index) in news_tags"
            :key="index"
          >
            <h2 class="f-14 medium">{{ _.get(tag, "title") }}</h2>
            <div class="news_inner_header--tag__x w-full">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16.97"
                height="16.97"
                viewBox="0 0 16.97 16.97"
              >
                <path
                  id="Combined_Shape"
                  data-name="Combined Shape"
                  d="M5,11V7H1A1,1,0,0,1,1,5H5V1A1,1,0,0,1,7,1V5h4a1,1,0,0,1,0,2H7v4a1,1,0,0,1-2,0Z"
                  transform="translate(8.485 16.97) rotate(-135)"
                  fill="#fff"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumb from "@/components/smartComponents/BreadCrumb";
export default {
  components: {
    BreadCrumb
  },
  data() {
    return {};
  },
  props: ["content", "news_category", "news_title", "news_tags"],
  mounted() {},
  computed: {
    tags() {
      return this.$store.state.main.indx.terms.tags_news;
    },
    share_icons() {
      let socialList = [];
      let socialSvgs = _.get(
        this.$store.state.main.indx,
        "widgets.share_icons"
      );
      let uri = encodeURI(
        window.location.protocol +
          "//" +
          window.location.host +
          "" +
          this.$route.path +
          window.location.search
      );

      if (!socialSvgs) return socialList;
      console.log(socialSvgs, 'socialkscsgs')
      for (let i in socialSvgs) {
        if(socialSvgs[i] === null) return;
        socialList.push({
          svg: socialSvgs[i].svg,
          url: socialSvgs[i].url + uri
        });
      }

      return socialList;
    }
  },
  methods: {
    openSharePopup(url) {
      let winWidth = 650;
      let winHeight = 350;
      let winTop = 200;
      let winLeft = screen.width / 2 - winWidth / 2;
      window.open(
        url,
        "sharer",
        "top=" +
          winTop +
          ",left=" +
          winLeft +
          ",toolbar=0,status=0,width=" +
          winWidth +
          ",height=" +
          winHeight
      );
    }
  }
};
</script>


<style>
.w-full{
  width: 100%;
}
</style>